import { InjectionToken } from '@angular/core';
import { DictionaryRepository } from '@softline/core';
import { Favorite } from './favorite';

export const SOFTLINE_REPOSITORY_FAVORITE = new InjectionToken<DictionaryRepository<Favorite<any>[], Favorite<any>[]>>('SOFTLINE_REPOSITORY_FAVORITE')
export const SOFTLINE_NAME_FAVORITES_OBJECT_STORE = 'favorites';
